// extracted by mini-css-extract-plugin
module.exports = {"root":"RoundedButton_root__G2smJ"};